var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoldericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 66,
    viewBox: "0 0 85 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.125 3.125H31.941L31.109 1.9609C30.2301 0.734299 28.8043 0 27.2965 0H7.8125C3.5039 0 0 3.5039 0 7.8125V57.8125C0 62.1211 3.5039 65.625 7.8125 65.625H76.5625C80.8711 65.625 84.375 62.1211 84.375 57.8125V9.3745C84.375 5.9292 81.5703 3.125 78.125 3.125ZM73.4375 54.687H62.4995C61.6363 54.687 60.937 53.9878 60.937 53.1245C60.937 52.2612 61.6363 51.562 62.4995 51.562H73.4375C74.3008 51.562 75 52.2612 75 53.1245C75 53.9878 74.3008 54.687 73.4375 54.687ZM81.25 12.539C79.9414 11.5468 78.3281 10.9374 76.5625 10.9374H38.3285C37.8246 10.9374 37.352 10.6913 37.0551 10.2851L34.1723 6.24986H78.1213C79.844 6.24986 81.2463 7.65216 81.2463 9.37486V12.539L81.25 12.539Z",
    fill: "url(#paint0_linear_3038_22)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3038_22",
    x1: 42.1875,
    y1: 0,
    x2: 42.1875,
    y2: 65.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldericon);
export default __webpack_public_path__ + "static/media/folder icon.3f6e9346ac14cd537d42156eba54a76e.svg";
export { ForwardRef as ReactComponent };